// extracted by mini-css-extract-plugin
module.exports = {"content-title":"seoquicklinks_content-title__MIVyK","content-links":"seoquicklinks_content-links__W4Loj"};